const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		children: {
			ZZ_ENPHANTS_M10010: {
				name: ['(客製)新增員工建檔', '(客製)新增員工建檔', '(客製)新增員工建檔'],
				url: '/zz_enphants_m10010',
			},
			ZZ_ENPHANTS_M410040: {
				name: ['(客製)打卡明細檢核', '(客製)打卡明細檢核', '(客製)打卡明細檢核'],
				url: '/zz_enphants_m410040',
			},
			ZZ_LESENPHANTS_M60010: {
				name: ['(客製)新增特殊出勤時間', '(客製)新增特殊出勤時間', '(客製)新增特殊出勤時間'],
				url: '/zz_lesenphants_m60010',
			},
		},
	},
};

module.exports = (paidMenu) => {
    return { ...paidMenu, ...custMenu };
};